import { Link } from "react-router-dom";
import { ArrowRight, Star } from "lucide-react";
import { useBrokers } from "@/lib/format";
import { useLead } from "@/components/layout/Layout";

export const BrokerTable = ({ items, limit }) => {
  const openLead = useLead();
  return (
    <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white">
      <table data-testid="brokers-table" className="w-full text-sm">
        <thead className="bg-[#F8FAFC] text-left text-xs uppercase tracking-wider text-slate-500">
          <tr>{["Broker", "Delivery", "Intraday", "F&O", "Annual AMC", "Active clients", "Rating", ""].map((h) => <th key={h} className="px-3 py-3 whitespace-nowrap">{h}</th>)}</tr>
        </thead>
        <tbody>
          {items.slice(0, limit).map((b) => (
            <tr key={b.id} data-testid={`broker-row-${b.id}`} className="border-t border-slate-100 hover:bg-slate-50/70">
              <td className="px-3 py-4 min-w-[180px]"><p className="font-semibold text-slate-900">{b.name}</p><span className={`text-[11px] font-bold ${b.type === "Discount" ? "text-[#059669]" : "text-amber-700"}`}>{b.type}</span></td>
              <td className="px-3 py-4 whitespace-nowrap font-semibold">{b.delivery}</td>
              <td className="px-3 py-4 whitespace-nowrap">{b.intraday}</td>
              <td className="px-3 py-4 whitespace-nowrap">{b.fno}</td>
              <td className="px-3 py-4 whitespace-nowrap">{b.amc}</td>
              <td className="px-3 py-4 font-mono whitespace-nowrap">~{b.active_clients_lakh} L</td>
              <td className="px-3 py-4"><span className="inline-flex items-center gap-1 font-semibold"><Star className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />{b.rating}</span></td>
              <td className="pl-3 pr-5 py-4"><button data-testid={`broker-open-${b.id}`} onClick={() => openLead({ id: b.id, company_name: b.name })} className="h-9 px-4 rounded-lg bg-[#10B981] hover:bg-[#059669] text-[#0F172A] font-bold text-xs whitespace-nowrap transition-colors">Open Account</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const BrokerSnapshot = () => {
  const { data } = useBrokers();
  return (
    <section data-testid="broker-snapshot" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#059669]">Stock Brokers</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight mt-2">Brokerage, side by side</h2>
        </div>
        <Link to="/stock-brokers" data-testid="brokers-view-all" className="inline-flex items-center gap-1.5 text-sm font-bold text-[#059669]">Compare all {data?.items?.length || ""} brokers <ArrowRight className="w-4 h-4" /></Link>
      </div>
      <BrokerTable items={data?.items || []} limit={6} />
      <p className="text-xs text-slate-500 mt-3">{data?.note}</p>
    </section>
  );
};
